import { nominatedPurchasersKeys, useNodeService } from "@fero/hooks";
import { useQueryClient } from "@tanstack/react-query";

export const useSaveNominatedPurchaserDeliveryAddressQuery = () => {
  const nodeService = useNodeService();
  const queryClient = useQueryClient();
  return nodeService.updateSavedDeliveryInfo.useMutation({
    onSuccess: (_, variables) => {
      const { params } = variables;
      const { nominatedPurchaserId } = params;
      queryClient.invalidateQueries(
        nominatedPurchasersKeys.getPurchaserSavedDeliveryInfoList(
          nominatedPurchaserId,
        ),
      );
    },
  });
};
